(function(){
    'use strict'

    angular
    .module('app.procesarPlanilla')
    .controller('PlanillaProcesadaDetalle', PlanillaProcesadaDetalle);

    PlanillaProcesadaDetalle.$inject = ['$scope', '$animationsSrv', '$routeParams', 'ProcesarPlanillaService', 'logger', '$location', 'UserInfoService', 'moment'];

    function PlanillaProcesadaDetalle($scope, $animationsSrv, $routeParams, ProcesarPlanillaService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.planillaId = $routeParams.calendarizacionId ? $routeParams.calendarizacionId : 0;
        vm.empleadoId = $routeParams.empleadoId ? $routeParams.empleadoId : 0;
        vm.detalle = [];

        vm.title = 'Planilla Procesada Detalle';

        getAll();

        function getAll(){

            if(vm.planillaId && vm.empleadoId){
                var promise = ProcesarPlanillaService.getPlanillaProcesadaDetalle(vm.planillaId, vm.empleadoId)
                .then(function(detalle){
                    vm.detalle = detalle;
                })
                .catch(function(error){
                    $logger.error('Error al obtener los datos del detalle.');
                }); 
            }
            else{
                $logger.error('No se ha definido la planilla o el empleado.');
            }
        
        };

        vm.updateCantidad = function(cantidad) {
            var promise = ProcesarPlanillaService.updateCantidad(cantidad);
                
            promise
            .then(function(response){
                cantidad.editar = 0;
                getAll();
                logger.success('Cantidad actualizada con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                    logger.error(`Hubo un error al actualizar la cantidad: ${error.data.Message}`);
                        break;
                
                    default:
                        logger.error('Hubo un error al actualizar la cantidad');
                        break;
                }
            }); 
        };

        vm.updateDeduccion = function(deduccion) {
            $animationsSrv.scrollToTop();
            var promise = ProcesarPlanillaService.updateDeduccion(deduccion);
                
            promise
            .then(function(response){
                deduccion.editar = 0;
                getAll();
                logger.success('Deduccion actualizada con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                    logger.error(`Hubo un error al actualizar la Deduccion: ${error.data.Message}`);
                        break;
                
                    default:
                        logger.error('Hubo un error al actualizar la Deduccion');
                        break;
                }
            }); 
        };

        vm.updateDevengado = function(devengado) {
            $animationsSrv.scrollToTop();
            var promise = ProcesarPlanillaService.updateDevengado(devengado);
                
            promise
            .then(function(response){
                devengado.editar = 0;
                getAll();
                logger.success('Devengado actualizado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                    logger.error(`Hubo un error al actualizar el Devengado: ${error.data.Message}`);
                        break;
                
                    default:
                        logger.error('Hubo un error al actualizar el Devengado');
                        break;
                }
            }); 
        };

    }
})();